<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'月目标管理'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn w-newColumn">
              <el-form-item label="创客">
      <el-input v-model="q.checkName" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
    </el-form-item>
              <!--<el-form-item label="抢入链群">-->
              <!--    <el-select filterable v-model="q.searchLianqun" clearable placeholder="请选择"-->
              <!--    >-->
              <!--        <el-option-->
              <!--                v-for="(item,index) in lianqunList"-->
              <!--                :key="item.chainGroupCode"-->
              <!--                :label="item.chainGroupName"-->
              <!--                :value="item.chainGroupCode">-->
              <!--        </el-option>-->
              <!--    </el-select>-->
              <!--</el-form-item>-->
              <el-form-item label="区域">
                  <el-select filterable v-model="q.searchQuyu" clearable placeholder="请选择"
                  >
                      <el-option
                              v-for="(item,index) in quyuList"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="链群类型">
              <el-select filterable v-model="q.lqType" clearable placeholder="请选择"
              >
                <el-option label="创单链群" value="0"></el-option>
                <el-option label="体验链群" value="1"></el-option>
              </el-select>
            </el-form-item>
               <el-form-item label="部门">
            <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
            >
              <el-option
                  v-for="(item,index) in deptList"
                  :key="item.dept"
                  :label="item.dept"
                  :value="item.dept">
              </el-option>
            </el-select>
          </el-form-item>
			  </div>
              <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="年度">
                      <el-select filterable v-model="q.year" clearable placeholder="请选择"
                      >
                          <el-option
                                  v-for="(item,index) in qyearList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item  label="月" class="h-elformWrap-2" prop="username">
                      <el-select filterable v-model="q.month" clearable placeholder="请选择"
                      >
                          <el-option
                                  v-for="(item,index) in monthList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                          </el-option>
                      </el-select>
                  </el-form-item>

              </div>

            <div class="h-formBtnOut h-columnCenter">
				<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
				<el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                    新建目标
                </el-button>

            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
		  max-height="560"
          style="width: 100%"
          >
<!--              <el-table-column prop="daquName" label="大区" width="50" :show-overflow-tooltip="true"></el-table-column>-->
            <el-table-column prop="userName" label="创客" width="70" ></el-table-column>
            <!--<el-table-column prop="lianqunName" label="抢入链群" width="80"></el-table-column>-->
            <el-table-column prop="quyuName" label="区域" width="80" ></el-table-column>
            <el-table-column prop="year" label="年月" width="80" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                {{scope.row.year}}年{{scope.row.month}}月
                </template>
            </el-table-column>

<!--            <el-table-column prop="month" label="月" width="50" :show-overflow-tooltip="true"></el-table-column>-->

<!--            <el-table-column prop="cdate" label="提报时间"  width="90" :show-overflow-tooltip="true"></el-table-column>-->

            <el-table-column prop="targetMonthContent" label="目标内容" >
                <template slot-scope="scope">

                    <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;white-space: pre-wrap;">{{scope.row.targetMonthContent}}</pre></div>
                        <pre align="left" >{{scope.row.targetMonthContent}}</pre>
                    </el-tooltip>
                </template>
            </el-table-column>


            <el-table-column prop="summaryContent" label="总结">
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;white-space: pre-wrap;">{{scope.row.summaryContent}}</pre></div>
                        <pre align="left" >{{scope.row.summaryContent}}</pre>
                    </el-tooltip>
                </template>
            </el-table-column>

          <!-- 差异分析 -->
          <el-table-column prop="summaryContent" label="差异分析">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content"><pre align="left"  style="max-width: 500px;white-space: pre-wrap;">{{scope.row.diffAnalysis}}</pre></div>
                <pre align="left" >{{scope.row.diffAnalysis}}</pre>
              </el-tooltip>
            </template>
          </el-table-column>



            <el-table-column prop="comment" label="预实差评价"     >
                <template slot-scope="scope">
                    <el-input v-if="scope.row.id" type="textarea" v-model="scope.row.comment" placeholder="请输入" class="h-txtareaBox" rows = "2" ></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="sysScore" label="评价"   width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <brselect v-if="scope.row.id " class="h-tableInput" category="userCareLevel" :v="scope.row.sysScore" v-model="scope.row.sysScore"/>
                </template>
            </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="125"
          >
            <template slot-scope="scope">
				<div v-if="scope.row.id " style="text-align: left;">
                    <el-button
                        type="text"
                        size="small"
                        class="h-tableLink h-btn"
                        @click="showDetail(scope.row.id)"
                    >总结</el-button>
                    <el-button
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="updateDetail(scope.row.id)"
                            v-if="!scope.row.lqId"
                    >编辑</el-button>
                    <el-button
                            type="text"
                            size="small"
                            style="padding: 0;"
                            class="h-tableLink h-btn"
                            v-if="!scope.row.lqId"
                            @click="del(scope.row.id)">
                        删除
                    </el-button>
                </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'zhoumubiaopingjia'" @click="saveGrade">调整评分</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>
      <el-dialog :close-on-click-modal="false" :visible.sync="newDialog" class="h-dialog2">
          <div class="h-dialogImg">
              <div class="h-disTable">
                  <div class="h-tableCell">
                      <h1>新建目标</h1>
                  </div>
              </div>
          </div>
          <div class="h-formLines">
              <div style="padding: 12px;" class="dialogout X-dai">
                  <el-form :model="add" label-position="right" :inline="true"
                           class="demo-ruleForm h-formbLine h-formbLine1">
                      <div class="h-rowCon">
                          <div class="h-pieceIn2">
                              <div class="h-pieceCon2">
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="类型" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                              <el-option
                                                      v-for="(item,index) in typeList"
                                                      :key="item.type"
                                                      :label="item.text"
                                                      :value="item.type">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                  </div>
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.year"  placeholder="请选择"
                                                     @change="getWeeksBySelectYear">
                                              <el-option
                                                      v-for="(item,index) in yearList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.month" placeholder="请选择"
                                                     @change="getLianqunBySelectMonth"
                                                     >
                                              <el-option
                                                      v-for="(item,index) in monthList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item label="链群" v-if="this.addlianqunList.length >0">
                                          <el-select filterable v-model="add.lianqun" clearable placeholder="请选择"
                                          >
                                              <el-option
                                                      v-for="(item,index) in addlianqunList"
                                                      :key="item.chainGroupCode"
                                                      :label="item.chainGroupName"
                                                      :value="item.chainGroupCode">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>

                                      <el-form-item label="目标内容" class="h-elformWrap-1">
                                          <el-input type="textarea" v-model="add.targetContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                      </el-form-item>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </el-form>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                  <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
                  <!--                    </el-button>-->
                  <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
              </div>
          </div>
      </el-dialog>


      <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" v-loading="showloading" class="h-dialog2">
          <div class="h-dialogImg">
              <div class="h-disTable">
                  <div class="h-tableCell">
                      <h1>总结</h1>
                  </div>
              </div>
          </div>
          <div class="h-formLines">
              <div style="padding: 12px;" class="dialogout X-dai">
                  <el-form :model="add" label-position="right" :inline="true"
                           class="demo-ruleForm h-formbLine h-formbLine1">
                      <div class="h-rowCon">
                          <div class="h-pieceIn2">
                              <div class="h-pieceCon2">
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="类型" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                              <el-option
                                                      v-for="(item,index) in typeList"
                                                      :key="item.type"
                                                      :label="item.text"
                                                      :value="item.type">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                  </div>
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.year" disabled  placeholder="请选择"
                                                     @change="getWeeksBySelectYear">
                                              <el-option
                                                      v-for="(item,index) in yearList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.month" disabled placeholder="请选择"
                                          >
                                              <el-option
                                                      v-for="(item,index) in monthList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-3" prop="username">
                                          <el-select filterable v-model="add.week" disabled  placeholder="请选择"
                                          >
                                              <el-option
                                                      v-for="(item,index) in weekList"
                                                      :key="item.week"
                                                      :label="item.weekStr"
                                                      :value="item.week">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.lianqunName" label="链群" class="h-elformWrap-1">
                                        {{add.lianqunName}}
                                      </el-form-item>

                                      <el-form-item label="目标内容" class="h-elformWrap-1">
                                          <el-input type="textarea" v-model="add.targetContent" disabled placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                      </el-form-item>

                                      <el-form-item label="总结" class="h-elformWrap-1">
                                          <el-input type="textarea" v-model="add.summaryContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                      </el-form-item>

                                    <el-form-item label="差异分析" class="h-elformWrap-1">
                                      <el-input type="textarea" v-model="add.diffAnalysis" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                    </el-form-item>

                                  </div>
                              </div>
                          </div>
                      </div>
                  </el-form>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                  <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
              </div>
          </div>
      </el-dialog>

      <el-dialog :close-on-click-modal="false" :visible.sync="updateDialog" v-loading="updateloading" class="h-dialog2">
          <div class="h-dialogImg">
              <div class="h-disTable">
                  <div class="h-tableCell">
                      <h1>修改目标</h1>
                  </div>
              </div>
          </div>
          <div class="h-formLines">
              <div style="padding: 12px;" class="dialogout X-dai">
                  <el-form :model="add" label-position="right" :inline="true"
                           class="demo-ruleForm h-formbLine h-formbLine1">
                      <div class="h-rowCon">
                          <div class="h-pieceIn2">
                              <div class="h-pieceCon2">
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="类型" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                              <el-option
                                                      v-for="(item,index) in typeList"
                                                      :key="item.type"
                                                      :label="item.text"
                                                      :value="item.type">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                  </div>
                                  <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="年度" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.year"  placeholder="请选择"
                                                     @change="getWeeksBySelectYear">
                                              <el-option
                                                      v-for="(item,index) in yearList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-2" prop="username">
                                          <el-select filterable v-model="add.month" placeholder="请选择"
                                          >
                                              <el-option
                                                      v-for="(item,index) in monthList"
                                                      :key="item"
                                                      :label="item"
                                                      :value="item">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-3" prop="username">
                                          <el-select filterable v-model="add.week"  placeholder="请选择"
                                          >
                                              <el-option
                                                      v-for="(item,index) in weekList"
                                                      :key="item.week"
                                                      :label="item.weekStr"
                                                      :value="item.week">
                                              </el-option>
                                          </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="add.lianqunName" label="链群" class="h-elformWrap-1">
                                          {{add.lianqunName}}
                                      </el-form-item>

                                      <el-form-item label="目标内容" class="h-elformWrap-1">
                                          <el-input type="textarea" v-model="add.targetContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                      </el-form-item>

                                  </div>
                              </div>
                          </div>
                      </div>
                  </el-form>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                  <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
              </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import createMonthGoal from "../../../api/guanhuai/createMonthGoal";
export default {
  data() {
    return {
      //表单
      q: {
          year:new Date().getFullYear(),
          cdsDate:null,
          checkName:null,
          type : 1,
          pageSize: 10,
          pageNo: 1,
          total:0,
      },
      add:{
          year :new Date().getFullYear(),
          type : 1,
          month :new Date().getMonth()+1,
          diffAnalysis:"",
          summaryContent:""
      },
      isfb:1,
      showhistory:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
        quyuList:[],
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
      //发布排行
      dialogFlag:false,

      sumRank:[],
        yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
        qyearList:[],
        typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        lianqunList : [],
        addlianqunList : [],
        weekList :[],
        qweekList :[],
        deptList: [],
        newDialog: false,
        showDialog:false,
        updateDialog:false,
        showloading:false,
        updateloading:false,
      nosum:'',
      nosoc:'',
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },
    };
  },
  created() {
    this.getAllLianqun();
      this.getQuyu();
    this.getWeeks(new Date().getFullYear());

    for(var i =2021;i<new Date() .getFullYear()+2;i++){
        this.qyearList.push(i);
    }
    this.getDept();

  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
      readd(){
          this.add={
              year :new Date().getFullYear(),
                  type : 2,
                  month :new Date().getMonth()+1
          }
      },
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },
        getQuyu(){
            ss.RiqPingj.selectAllQuyu().then(rd => {
                this.quyuList = rd;
            })
        },
        getLianqun(q){
            ss.createMonthGoal.getLianqun(q).then(rd => {
                this.lianqunList = rd;
            })
        },
        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getqWeeks(y,z){
            ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
                this.qweekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
            //     this.addlianqunList = rd;
            // })
        },
        getLianqunBySelectMonth(){
            // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
            //     this.addlianqunList = rd;
            // })
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        //调整评分
        saveGrade(){

            ss.MuBiao.tzGrade({"list":this.tableData}).then(rd => {
                this.$msg.msgs("调整保存成功");
                this.query();
            })


        },
        commitCreate() {
            if(!this.add.type){
                this.$message({
                    type: "error",
                    message: '类型不能为空'
                });
                return false;
            }
            if(!this.add.year){
                this.$message({
                    type: "error",
                    message: '年度不能为空'
                });
                return false;
            }
            if(this.add.type == 1 &&!this.add.month){
                this.$message({
                    type: "error",
                    message: '月度不能为空'
                });
                return false;
            }
            if(this.add.type == 2 &&!this.add.week){
                this.$message({
                    type: "error",
                    message: '周不能为空'
                });
                return false;
            }
            if(!this.add.targetContent){
                this.$message({
                    type: "error",
                    message: '目标内容不能为空'
                });
                return false;
            }

            if (this.add.summaryContent){
              if(!this.add.diffAnalysis){
                this.$message({
                  type: "error",
                  message: '未提交差异分析不能进行总结！'
                });
                return false;
              }
            }

            if(this.add.type == 1)
                this.add.week = null
            if(this.add.type == 2)
                this.add.month = null

            ss.MuBiao.saveOrUpdate(this.add).then(response => {
                if (response.f) {
                    this.$message({
                        type: "success",
                        message: response.msg
                    });
                    //this.readd();
                    this.query();
                    this.newDialog = false;
                    this.showDialog = false;
                    this.updateDialog = false;
                } else {
                    this.$message({
                        type: "error",
                        message: response.msg
                    });
                }

            })
        },
        del(id){
            this.$confirm("确定要删除吗？", '提示')
                .then(_ => {
                    ss.MuBiao.del({id:id}).then(response => {
                        this.query();
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                    })
                })
                .catch(_ => {
                })
        },
        showDetail(id){
            this.showDialog = true;
            this.showloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.showloading = false;
            });
        },
        updateDetail(id){
            this.updateDialog = true;
            this.updateloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.updateloading = false;
            });
        },
        getAllLianqun(){
            ss.createMonthGoal.getAllLianqun().then(rd => {
                this.lianqunList = rd;
            })
        },
        query(){
          ss.MuBiao.page(this.q).then(rd => {
            this.q.total = rd.total;
            this.tableData = rd.records;
          });
        },
        create(){
            // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
            //     this.addlianqunList = rd;
            // })
            this.add = {
                year :new Date().getFullYear(),
                    type : 1,
                    month :new Date().getMonth()+1
            }
            this.newDialog = true;
        },
//取消按钮
        exit() {
            this.newDialog = false;
            this.showDialog = false;
            this.updateDialog = false;
        },
    handleFilter() {
      this.query();
    },
    checkRank() {
      this.$router.push("/paiming");
    },

    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },

      //明细导出
      exportExcel() {
        updownfile.down("/api/swyl/v1/mubiao/userDailyTarget/downloadExcel",this.q,"post",'data');
      },

    //重置
    rest() {
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
          pageSize: pageSize,
          pageNo: pageNo,
          total:total,
      }
    },
  },
  mounted() {
    this.query();
  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.5rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
</style>
